import gql from "graphql-tag";

export default gql`
  query FeatureFlags {
    featureFlags
  }
`;
